import styled from "styled-components";

export const InputCheckSyle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    margin: 0;
    padding: 0%;
    cursor: pointer;
    padding: 2px 0;
    color: ${({ theme }) => theme.colors.secondaryText};
    font-weight: normal;
  }

  input {
    cursor: pointer;
    appearance: none;
    border-radius: 5px;
    min-height: 20px;
    min-width: 20px;
    border: 2px solid ${({ theme }) => theme.colors.lightGray};
    transition: 0.2s all linear;
    position: relative;
    vertical-align: middle;
    display: flex;
    flex-direction: column;
    justify-content: top;
    &:focus {
      box-shadow: none;
      outline: none;
    }
  }

  input:checked {
    border: 2px solid ${({ theme }) => theme.colors.lightBlue};
  }
  &:checked {
    opacity: 1 !important;
  }

  input[type="checkbox"] {
    border-radius: 5px;
    background: white;
    &:checked {
      background-color: ${({ theme }) => theme.colors.lightBlue};
    }
    &:after {
      content: "";
      display: block;
      left: 0;
      top: 0;
      position: absolute;
    }

    &:not(.switch) {
      &:after {
        width: 6px;
        height: 10px;
        border: 2px solid white;
        border-top: 0;
        border-left: 0;
        left: 5px;
        top: 2px;
        transform: rotate(45deg);
      }
      &:checked {
        --o: 1;
      }
    }
  }
`;
